import { AdminLayout } from "@/components/layout/admin-layout";
import { identifyPostHogUser, setDatadogUser } from "@/lib/analytics-loader";
import { getCachedSession, sessionQueryOptions } from "@/lib/queries/session";
import { Role } from "@repo/core";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin")({
  // Auth guard
  beforeLoad: async ({ context, location }) => {
    let session = getCachedSession(context.queryClient);

    if (session === undefined) {
      session = await context.queryClient.fetchQuery(sessionQueryOptions());
    }

    if (!session?.user || !session?.session) {
      throw redirect({
        to: "/login",
        search: { returnTo: location.href },
      });
    }

    if (
      session.user.role !== Role.Admin &&
      session.user.role !== Role.SuperAdmin
    ) {
      throw redirect({
        to: "/",
      });
    }

    void Promise.all([
      setDatadogUser(session.user),
      identifyPostHogUser(session.user),
    ]);

    return { user: session.user, session };
  },
  component: AdminLayoutWrapper,
});

function AdminLayoutWrapper() {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
